<div class="mobile-section">
  <div class="mobile-shell">

    <!-- Left: stacked images -->
    <div class="mobile-images">
      <div class="mobile-blob" aria-hidden="true"></div>
      <img
        class="mobile-img mobile-img--back"
        src="images/webps/mobile-view1.png"
        alt="Mobile view receipt"
      />
      <img
        class="mobile-img mobile-img--front"
        src="images/webps/mobile-view.png"
        alt="Mobile view bill"
      />
    </div>

    <!-- Right: copy -->
    <div class="mobile-copy">
      <span class="mobile-star" aria-hidden="true">&#9733;</span>
      <h2 class="mobile-heading">
        Enjoy the <span class="mobile-heading--highlight">mobile</span><br />experience
      </h2>
      <p class="mobile-desc">
        <strong>Your mobile companion.</strong> Take pictures of your expenses,
        and let the Artificial Intelligence do the rest!
      </p>
    </div>

  </div>
</div>
